/* eslint-disable no-param-reassign */
import { create } from 'zustand';
import { produce } from 'immer';
import { shared } from '../../contexts/utils/zustand-use-broadcast';
import { loadTutorialState, saveTutorialState } from './tutorial-fhir-api';

/**
 * This store is to be used by the hook useTutorial only
 * No other component should use this store
 */

/**
 * flags: Object of flags to keep track of state
 */

export const useTutorialStoreShared = create(
	shared((set, get) => ({
		flags: {},
		tutorialState: {},
		initialized: true,
		isInitialized: () => get().initialized,
		getTutorialState: tutorialName => get().tutorialState[tutorialName],
		fetchTutorialState: async (__config, tutorialName) => {
			if (get().flags.tutorialStateFetched) return;
			set(state =>
				produce(state, draft => {
					draft.flags.tutorialStateFetched = true;
				})
			);
			const tutorialState = await loadTutorialState({ __config, tutorialName });
			set(state =>
				produce(state, draft => {
					draft.tutorialState = tutorialState || {};
				})
			);
		},
		setTutorialState: (tutorialName, newState) => {
			if (!tutorialName) return;
			set(state =>
				produce(state, draft => {
					const { tutorialState } = draft;
					tutorialState[tutorialName] = newState;
				})
			);
		},
		persistTutorialState: async (__config, tutorialName) => {
			const { tutorialState } = get();
			const keysToRemove = ['isDriveStarted', 'isDriveClosed'];
			const payload = Object.entries(tutorialState).reduce((acc, [key, value]) => {
				// Assuming value is an object and we want to filter its keys
				const filteredValue = Object.entries(value).reduce((accInner, [innerKey, innerValue]) => {
					if (!keysToRemove.includes(innerKey)) {
						// eslint-disable-next-line no-param-reassign
						accInner[innerKey] = innerValue;
					}
					return accInner;
				}, {});
				acc[key] = filteredValue;
				return acc;
			}, {});
			await saveTutorialState({ __config, tutorialState: payload, tutorialName });
		},
		resetTutorialShared: () => set(() => ({ queue: [], tutorials: [], initialized: true })),
	}))
);
